<div [ngClass]="containerClasses" class="content-container">
  <ish-content-slot
    [wrapper]="true"
    [slot]="'app_sf_base_cm:slot.container.content.pagelet2-Slot'"
    [pagelet]="pagelet()"
  >
    @for (slotPagelet of contentSlotPagelets; track slotPagelet) {
    <ish-content-pagelet [pageletId]="slotPagelet" />
    }
  </ish-content-slot>
</div>
